<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-advanced-contact" size="xl" scrollable centered button-size="sm" @hidden="onReset">
      <template #modal-title>
        <i class="fas fa-user"></i> ADICIONAR CONTATOS AVANÇADOS
      </template>
      <div class="pl-3 pr-3">
        <div class="form-group row">
          <div class="col-md-4">
            <label><small class="text-danger" v-if="form.document.required">*</small> CPF/CNPJ:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o CPF ou CNPJ'"
                            v-model="form.document.value"
                            :size="form.document.maxlength"
                            :required="form.document.required"
                            :state="form.document.state"
                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                            ></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <label><small class="text-danger" v-if="form.nomeAssociado.required">*</small> Nome do Associado:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Nome do Associado'"
                            v-model="form.nomeAssociado.value"
                            :size="form.nomeAssociado.maxlength"
                            :required="form.nomeAssociado.required"
                            :state="form.nomeAssociado.state"
                            ></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <label><small class="text-danger" v-if="form.numSisbr.required">*</small> Número SisBR:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Número SisBR'"
                            v-model="form.numSisbr.value"
                            :size="form.numSisbr.maxlength"
                            :required="form.numSisbr.required"
                            :state="form.numSisbr.state"
                            ></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-4">
            <label><small class="text-danger" v-if="form.numeroPA.required">*</small> PA:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Número do PA'"
                            v-model="form.numeroPA.value"
                            :size="form.numeroPA.maxlength"
                            :required="form.numeroPA.required"
                            :state="form.numeroPA.state"
                            ></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <label><small class="text-danger" v-if="form.gerenteSisbr.required">*</small> Gerente SisBR:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Nome do Gerente de SisBR'"
                            v-model="form.gerenteSisbr.value"
                            :size="form.gerenteSisbr.maxlength"
                            :required="form.gerenteSisbr.required"
                            :state="form.gerenteSisbr.state"
                            ></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <label><small class="text-danger" v-if="form.gerenteRelecionamento.required">*</small> Gerente Relacionamento:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Nome do Gerente de relacioanemnto'"
                            v-model="form.gerenteRelecionamento.value"
                            :size="form.gerenteRelecionamento.maxlength"
                            :required="form.gerenteRelecionamento.required"
                            :state="form.gerenteRelecionamento.state"
                            ></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-4">
            <label><small class="text-danger" v-if="form.clusterizacao.required">*</small> Clusterização:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Clusterização'"
                            v-model="form.clusterizacao.value"
                            :size="form.clusterizacao.maxlength"
                            :required="form.clusterizacao.required"
                            :state="form.clusterizacao.state"
                            ></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <label><small class="text-danger" v-if="form.nomeRegional.required">*</small> Regional:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Nome da Regional'"
                            v-model="form.nomeRegional.value"
                            :size="form.nomeRegional.maxlength"
                            :required="form.nomeRegional.required"
                            :state="form.nomeRegional.state"
                            ></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <label><small class="text-danger" v-if="form.grupoEconomico.required">*</small> Grupo Econômico:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Código ou Nome do Grupo Econômico da Regional'"
                            v-model="form.grupoEconomico.value"
                            :size="form.grupoEconomico.maxlength"
                            :required="form.grupoEconomico.required"
                            :state="form.grupoEconomico.state"
                            ></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row pt-3 pb-3">
          <div class="col-md-12">
            <button type="button" class="btn btn-third btn-sm" v-b-tooltip.hover :title="'Pesquisar'" @click.prevent="onSearch">
              <i class="fas fa-search"></i>
              <span class="d-md-down-none"> Pesquisar</span>
            </button>
            <button type="button" class="btn btn-default btn-sm text-secundary"  v-on:click="onClear" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonClear">
              <i class="fa fa-minus-circle"></i>
              <span class="d-md-down-none"> {{$lang.Common.Buttons.Clear}}</span>
            </button>
          </div>
        </div>
        <Tables ref="tableGridAdv"
              :columns="['', 'SISBR', 'CPF/CNPJ', 'Nome', 'E-mail', 'Celular']"
              :showTipFooter="false"
              :showHeader="true"
              v-on:Load="onSearch">
        <tr v-for="(obj, index) in this.objList" v-bind:key="index">
          <TableColumn :IsCustom="true" :status="obj.inative ? 0 : 1">
            <input type="checkbox" :value="obj" v-model="selected" />
          </TableColumn>
          <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.numSisbr.toString()"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.document"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.name ? obj.name.toUpperCase() : ''"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.email"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.telefone"
            />
            <!-- <TableColumn :IsCustom="true" :status="obj.inative ? 0 : 1">
              <a
                href="javascript:void(0)"
                v-if="obj.pessoa && obj.pessoa.telefone"
              >
                <span
                  v-for="(objTelefone, index) in obj.pessoa.telefone"
                  :key="index"
                >
                  <span v-if="objTelefone.tipoContato == 'CELULAR'">{{
                    objTelefone.telefone
                  }}</span>
                </span>
              </a>
            </TableColumn> -->
        </tr>
      </Tables>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Adicionar'"
            @click="onCreate"
          >
            <i class="fas fa-check-circle"></i>
            <span class="d-md-down-none"> Adicionar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import AdvancedContactForm from './advancecontact-form'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import CampaignListContactRepository from '@/shared/http/repositories/configurations/campaignlistcontact.js'

const AdvancedContactModal = {
  document: null,
  nomeAssociado: null,
  numSisbr: null,
  numeroPA: null,
  gerenteSisbr: null,
  gerenteRelecionamento: null,
  clusterizacao: null,
  nomeRegional: null,
  grupoEconomico: null,
  situacaoContaCapital: null
}

export default {
  name: 'ModalSegmentAdvancedContactAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: AdvancedContactModal,
      form: AdvancedContactForm,
      campanhaListaId: null,
      filters: null,
      selected: [],
      selectAll: false,
      persons: []
    }
  },
  methods: {
    onLoad () {
      this.onClear()
    },
    onClear () {
      this.onReset()
    },
    showModal (campanhaListaId) {
      this.$refs['modal-advanced-contact'].show()
      this.$nextTick(() => {
        this.onReset()
        this.campanhaListaId = campanhaListaId
      })
    },
    hideModal () {
      this.onReset()
      this.$refs['modal-advanced-contact'].hide()
      this.$emit('created')
    },
    onReset () {
      Tools.ClearDataForms(this.form, this.data)
      this.campanhaListaId = null
      this.persons = []
      this.selected = []
      this.selectAll = false
      this.objList = []
      this.$refs.tableGridAdv && this.$refs.tableGridAdv.Clear()
    },
    onSearch () {
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        loading.push()

        if (this.data.document) {
          let document = this.data.document.replaceAll('-', '').replaceAll('.', '').replaceAll('/', '')
          this.data.document = document
        }

        AssociateRepository.Search(Tools.getFilters(this.data), this.$refs.tableGridAdv.pagingLimit, this.$refs.tableGridAdv.pagingIndex)
          .then((response) => {
            this.onResultGrid(this.gridData(response), this.$refs.tableGridAdv)
          })
          .catch(this.onException)
      }
    },
    select () {
      if (!this.selectAll) {
        for (let i in this.objList) {
          this.selected.push(this.objList[i])
        }
      }
    },
    onCreate () {
      if (this.selected) {
        this.persons = []
        this.selected.forEach(element => {
          // if (element.pessoa) {
          //   let telefone = null
          //   if (element.pessoa.telefone) {
          //     telefone = element.pessoa.telefone.find(x => x.tipoContato === 'CELULAR').telefone
          //   }
          let contact = {
            campanhaListaId: this.campanhaListaId,
            documento: element.document ? element.document : null,
            nome: element.nome ? element.nome : null,
            email: element.email ? element.email : null,
            celular: element.telefone ? element.telefone : null
          }
          this.persons.push(contact)
          // }
        })
        if (this.persons) {
          loading.push()
          CampaignListContactRepository.Import(this.persons)
            .then((response) => {
              if (response.status === 200) {
                this.hideModal()
                toast.success(this.$lang.Common.Alerts.Success)
              }
            })
            .catch(this.onException)
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    },
    gridData (response) {
      let returnValue = []
      if (response.data && response.data.content && response.data.content.length > 0) {
        response.data.content.forEach(i => {
          if (i.pessoa.telefone && i.pessoa.telefone.length > 0) {
            i.pessoa.telefone.forEach(x => {
              if (x.tipoContato === 'CELULAR') {
                returnValue.push({
                  numSisbr: i.numSisbr ? i.numSisbr : '',
                  document: i.pessoa ? i.pessoa.document : '',
                  name: i.pessoa ? i.pessoa.nome : '',
                  email: i.pessoa ? i.pessoa.email : '',
                  telefone: x.telefone ? x.telefone : ''
                })
              }
            })
          } else {
            returnValue.push({
              numSisbr: i.numSisbr ? i.numSisbr : '',
              document: i.pessoa ? i.pessoa.document : '',
              name: i.pessoa ? i.pessoa.nome : '',
              email: i.pessoa ? i.pessoa.email : '',
              telefone: ''
            })
          }
        })
      }
      response.data.content = returnValue
      return response
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/campaign/campaignlist/components/add/modal/advancedcontactmodal/advancedcontact.vue